import React from 'react';
import './Lawfirmservices.css';
import Header from './Header';
import Footer from './Footer';

const Lawfirmservices = () => {
    return (
        <div>
            <Header />

            <div className="nd-law-page">
                <div className="nd-law-container container">
                    {/* Hero Header */}
                    <div className="nd-law-hero">
                        <div className="nd-law-badge">Legal & Regulatory Advisory</div>
                        <h1 className="nd-law-title">Law Firm Services</h1>
                    </div>

                    {/* Lead Intro Card */}
                    <div className="nd-law-lead-card">
                        <p>
                            Legal matters are an integral part of any business, and having access to expert legal advice is crucial for long-term success. Our Law Firm services provide you with comprehensive legal support, covering a wide range of business-related legal issues.
                        </p>
                    </div>

                    {/* 4 Core Legal Services Grid */}
                    <div className="nd-law-services-grid">
                        <div className="nd-law-service-card">
                            <div className="nd-law-icon-box">⚖️</div>
                            <h5><b>Corporate Law</b></h5>
                            <p>
                                We offer legal services related to the formation, governance, and operation of businesses. Our corporate law services include company registration, drafting and reviewing contracts, shareholder agreements, mergers and acquisitions, and corporate restructuring.
                            </p>
                        </div>

                        <div className="nd-law-service-card">
                            <div className="nd-law-icon-box">🛡️</div>
                            <h5><b>Intellectual Property (IP) Law</b></h5>
                            <p>
                                Protecting your intellectual property is essential in today’s competitive market. Our IP law services help you secure patents, trademarks, copyrights, and trade secrets. We also provide assistance with IP litigation and enforcement.
                            </p>
                        </div>

                        <div className="nd-law-service-card">
                            <div className="nd-law-icon-box">👥</div>
                            <h5><b>Employment Law</b></h5>
                            <p>
                                Navigating employment laws can be complex, but our legal experts are here to help. We offer services related to drafting employment contracts, handling disputes, ensuring compliance with labor laws, and managing employee-related litigation.
                            </p>
                        </div>

                        <div className="nd-law-service-card">
                            <div className="nd-law-icon-box">🤝</div>
                            <h5><b>Dispute Resolution</b></h5>
                            <p>
                                Disputes can arise in any business, and resolving them effectively is critical to maintaining relationships and protecting your interests. Our dispute resolution services include mediation, arbitration, and litigation, helping you achieve favorable outcomes with minimal disruption to your business.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Lawfirmservices;
